<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs'
  }
})

useHead({
  title: t('navigation.shareholderInformation.metatitle'),
  meta: [{ name: 'description', content: t('navigation.shareholderInformation.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('index')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.shareholderInformation.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.shareholderInformation.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <div class="imageEntete">
              <img name="image"
                   title=""
                   :src="t('global.pourcentatge-img')"
                   alt="image">
            </div>
            <p>KP Tissue Inc. (KPT) was created to acquire, and its business is limited to holding an interest in Kruger Products Inc.&nbsp;It currently holds a {{ $t('global.pourcentage-KP-inc')}}% interest in Kruger Products Inc. Kruger Products Inc. is Canada’s leading tissue products supplier by overall dollar and volume market share.</p>
            <p>Kruger Inc. is a private company founded in 1904 with operations in newsprint, forest/wood products, paperboard, energy and others. Kruger indirectly owns the remaining {{ $t('global.pourcentage-Kruger-inc')}}% limited equity interest in Kruger Products Inc.</p>
            <p>* As of {{ $t('global.dateLastChange')}}</p>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <div class="imageEntete">
              <img name="image"
                   title=""
                   :src="t('global.pourcentatge-img')"
                   alt="image">
            </div>
            <p>Papiers Tissu KP inc. (PTKP) a été créée dans le seul but d’acquérir une participation économique dans Produits Kruger inc., participation qui est actuellement de {{ $t('global.pourcentage-KP-inc')}}&nbsp;%. Produits Kruger inc. est le fournisseur de produits de papier qui a la plus importante part de marché globale au Canada, à la fois pour le volume et la valeur pécuniaire.</p>
            <p>Kruger inc. est une société fermée fondée en 1904. Elle exerce des activités dans plusieurs secteurs, notamment les papiers pour publications, les produits forestiers, les produits du bois, les cartons d’emballage et l’énergie. Kruger détient indirectement la participation limitée dans le capital&nbsp;restante de {{ $t('global.pourcentage-Kruger-inc')}}&nbsp;% dans Produits&nbsp;Kruger inc.</p>
            <p>* Au {{ $t('global.dateLastChange')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
